var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm1 13.91V12a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.91A5.999 5.999 0 0 1 2.087 9H4a.5.5 0 0 0 .5-.5v-1A.5.5 0 0 0 4 7H2.09A5.999 5.999 0 0 1 7 2.087V4a.5.5 0 0 0 .5.5h1A.5.5 0 0 0 9 4V2.087A5.999 5.999 0 0 1 13.91 7H12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.913A5.999 5.999 0 0 1 9 13.91z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a4bc0b81d36692a777f9ee20e35b90c6.svg";
export { ForwardRef as ReactComponent };